/**
 * Created by Nico on 18.07.2016.
 */
define('services/ClassificationService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('ClassificationService', ['$injector', ClassificationService]);
});

function ClassificationService($injector) {
	crudInstance = $injector.instantiate(CrudService);
	crudInstance.setType('Classification');

	angular.extend(this, crudInstance);

	return this;
}
;
